<ion-header>
    <ion-toolbar #toolbar>
        <ion-buttons slot="start">
            <ion-button appClick (clicked)="onClose()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title><span id="page-title-span">{{ 'Artikel auswählen' | translate }}</span></ion-title>
    </ion-toolbar>
</ion-header>


<ion-content #content>
    <!-- Artikelgruppe auswählen -->
    <ng-container *ngIf="ansichtArtikelgruppeAuswaehlen">
        <ion-fab vertical="bottom" horizontal="end" slot="fixed">
            <ion-fab-button appClick (clicked)="onSuchen()">
                <ion-icon name="search"></ion-icon>
            </ion-fab-button>
        </ion-fab>

        <ion-list class="artikel-list" lines="full">
            <ion-item *ngFor="let vo of artikelgruppenListe" appClick (clicked)="onArtikelgruppeSelected(vo)" [detail]="true" [style]="domSanitizationService.bypassSecurityTrustStyle(vo.style)">
                <!-- Artikelgruppe -->
                <ng-container *ngIf="vo.artikelgruppe">
                    <ion-avatar slot="start">
                        <img [src]="getIconSrc(vo)">
                    </ion-avatar>
                    <ion-label>
                        <h2>{{ vo.artikelgruppe.Name }}</h2>
                        <p class="beschreibung" *ngIf="vo.artikelgruppe.Beschreibung">{{ vo.artikelgruppe.Beschreibung }}</p>
                    </ion-label>
                </ng-container>

                <!-- Vertrag -->
                <ng-container *ngIf="vo.vertrag">
                    <ion-avatar slot="start">
                        <ion-icon name="document-attach-outline"></ion-icon>
                    </ion-avatar>
                    <ion-label>
                        <h2>{{ vo.vertrag.Bezeichnung }}</h2>
                        <p class="beschreibung">{{ 'Vertrag' | translate }}</p>
                    </ion-label>
                </ng-container>
            </ion-item>
        </ion-list>
    </ng-container>

    <!-- Artikel auswählen -->
    <ng-container *ngIf="ansichtArtikelAuswaehlen">
        <ion-list class="artikel-list">
            <ion-item appClick (clicked)="onClose()">
                <ion-icon name="arrow-back"></ion-icon>
                <ion-label>{{ 'Zurück' | translate }}</ion-label>
            </ion-item>
            <ion-item *ngFor="let a of artikelListe" appClick (clicked)="onArtikelSelected(a)">
                <ion-label>{{ a.text }}</ion-label>
            </ion-item>
        </ion-list>
    </ng-container>

    <!-- Vertragsposition auswählen -->
    <ng-container *ngIf="ansichtVertragspositionAuswaehlen">
        <ion-list class="artikel-list">
            <ion-item appClick (clicked)="onClose()">
                <ion-icon name="arrow-back"></ion-icon>
                <ion-label>{{ 'Zurück' | translate }}</ion-label>
            </ion-item>
            <ion-item *ngFor="let pos of vertragspositionListe" appClick (clicked)="onVertragspositionSelected(ausgewaehlteArtikelgruppe.vertrag, pos)">
                <ion-label>{{ pos.ArtikelKey }}: {{ pos.Bezeichnung }} ({{ pos.Menge }} {{ pos.Einheit }})</ion-label>
            </ion-item>
        </ion-list>
    </ng-container>

    <!-- Suchen -->
    <ng-container *ngIf="ansichtSuchen">
        <ion-searchbar [(ngModel)]="suchtext"
                       (ionChange)="onSearchChanged($event)"
                       (ionInput)="onSearchChanged($event)"
                       (ionCancel)="onSearchChanged($event)"
                       placeholder="{{ 'Suchen' | translate }}"
                       [debounce]="500"
                       #searchbar></ion-searchbar>

        <cdk-virtual-scroll-viewport *ngIf="sucheSichtbareItems.length" [itemSize]="88" minBufferPx="900" maxBufferPx="1350">
            <ion-list>
                <div *cdkVirtualFor="let item of sucheSichtbareItems; let index = index;">
                    <ion-item-divider *ngIf="getHeader(item, index, sucheSichtbareItems); let header">
                        <ion-label>{{ header.title }} <span class="subtitle" *ngIf="header.subtitle">{{ header.subtitle }}</span></ion-label>
                    </ion-item-divider>

                    <ion-item class='artikelitem' appClick (clicked)="onSuchItemSelected(item)">
                        <ion-label>
                            <h2>{{ item.text }}</h2>
                        </ion-label>
                    </ion-item>
                </div>
            </ion-list>
        </cdk-virtual-scroll-viewport>
    </ng-container>
</ion-content>